import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import SideBarStore from '@src/business-components/sidebar/store';
import SidebarContainer from '@src/components/sidebar-container';
import Link from '@src/components/link';
import cx from 'classnames';
const styles = require('./index.less');

const SideBar = ({ store }) => {
  store.use();

  return (
    <SidebarContainer store={store.sidebarContainerStore}>
      <div className={styles.sideBarContent} onClick={() => store.close()}>
        <div className={styles.root} onClick={e => e.stopPropagation()}>
          <Link className={styles.close} onClick={() => store.close()} />

          <div className={cx(styles.content, store.sidebarContainerStore.isActive && styles.contentAct)}>
            {store.navList.map((item, index) => {
              return (
                <div
                  className={cx(styles.navItem, store.currentIndex === index && styles.active, store.sidebarContainerStore.isActive && styles.slideIn)}
                  style={{
                    animationDelay: `${index * 0.1}s`,
                    animationFillMode: 'both'
                  }}
                  key={index}
                >
                  <Link onClick={() => store.changeMenu(item.index)}>{item.type}</Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </SidebarContainer>
  );
};

export default wrapStore(SideBar, SideBarStore);
